import {
  collapseSubTab,
  FlatRoute,
  QuestionnaireRoutes,
  selectQuestionnaireRoutes,
} from 'app/features/questionnaires/edit/routes/slice';
import { useScroller } from 'Components/ScrollContainer';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

export default function useQuestionnaireStepState() {
  const navigate = useNavigate();
  const { scrollToTop } = useScroller();
  const url = useLocation().pathname;
  const dispatch = useDispatch();
  const form = useFormContext();
  const routes = useSelector(selectQuestionnaireRoutes);
  const [current, next] = resolveCurrentAndNextRoutes(routes, url);

  if (!current || !next) {
    return { nextTitle: undefined, onNext: () => {}, current };
  }

  return {
    // onNext
    onNext: () => {
      // checks if used in a form context and the form is valid
      if (Object.keys(form?.formState?.errors || {}).length > 0) return;

      navigate(resolveNextPath(current, next, url));

      // scroll to top to reset the scroller because we may encounter two long consecutive tabs
      scrollToTop();

      // collapse the previous sub tab
      if (current.subTab !== next.subTab)
        dispatch(collapseSubTab(`${current.mainTab}.${current.subTab}`));
    },
    // nextTitle
    nextTitle: resolveNextTitle(current, next),
    current,
  };
}
function resolveCurrentAndNextRoutes(
  { flatMap, flatRoutes }: QuestionnaireRoutes,
  url: string,
) {
  const slashPath = url?.split('/').slice(4).join('/');
  const index = flatMap[slashPath];
  if (index === undefined) return [undefined, undefined];

  const current = flatRoutes[index];
  if (current === undefined) return [undefined, undefined];

  if (index === flatRoutes.length - 1) return [current, undefined];
  return [current, flatRoutes[index + 1]];
}

function resolveNextTitle(current: FlatRoute, next: FlatRoute) {
  return current.subTab === next.subTab
    ? next.leafTitle
    : current.mainTab === next.mainTab
    ? next.subTabTitle
    : next.mainTabTitle;
}

function resolveNextPath(current: FlatRoute, next: FlatRoute, url: string) {
  return url.replace(current.slashPath, next.slashPath);
}
